<template>
  <div v-if="visible" class="right-click-menu" :style="menuStyle" @contextmenu.prevent>
    <template v-for="(item, index) in filteredItems">
      <div v-if="item.type === 'divider'" :key="'d-' + index" class="rcm-divider"></div>
      <div v-else :key="'i-' + index"
           class="rcm-item"
           :class="{ 'rcm-danger': item.danger, 'rcm-disabled': item.disabled }"
           @click="onItemClick(item)">
        <i v-if="item.icon" :class="item.icon"></i>
        <span>{{ item.label }}</span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'RightClickMenu',
  props: {
    visible: { type: Boolean, default: false },
    x: { type: Number, default: 0 },
    y: { type: Number, default: 0 },
    items: { type: Array, default: function () { return []; } },
    context: { type: [Object, Number, String], default: null },
  },
  computed: {
    filteredItems: function () {
      return this.items.filter(function (item) {
        return item.show !== false;
      });
    },
    menuStyle: function () {
      return { left: this.x + 'px', top: this.y + 'px' };
    },
  },
  methods: {
    onItemClick: function (item) {
      if (item.disabled) return;
      this.$emit('select', item.action, this.context);
      this.$emit('update:visible', false);
    },
    close: function () {
      if (this.visible) this.$emit('update:visible', false);
    },
  },
  mounted: function () {
    var self = this;
    this._closeHandler = function () { self.close(); };
    document.addEventListener('click', this._closeHandler);
  },
  beforeDestroy: function () {
    document.removeEventListener('click', this._closeHandler);
  },
};
</script>

<style lang="less" scoped>
.right-click-menu {
  position: fixed;
  z-index: 9999;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.15);
  padding: 4px 0;
  min-width: 140px;
}

.rcm-item {
  padding: 6px 16px;
  font-size: 13px;
  color: #606266;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  transition: background 0.15s;

  i {
    font-size: 14px;
    width: 16px;
    text-align: center;
  }

  &:hover {
    background: #f5f7fa;
    color: #409eff;
  }

  &.rcm-danger:hover {
    background: #fef0f0;
    color: #f56c6c;
  }

  &.rcm-disabled {
    color: #c0c4cc;
    cursor: not-allowed;
    &:hover { background: transparent; color: #c0c4cc; }
  }
}

.rcm-divider {
  height: 1px;
  background: #ebeef5;
  margin: 4px 0;
}
</style>
